import { createContext } from 'react';

// ----------------------------------------------------------------------

export const JobCreationContext = createContext({});
